import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7cf0d183"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = { class: "text-gray-600" }
const _hoisted_4 = { class: "text-left p-4" }
const _hoisted_5 = { class: "p-4" }
const _hoisted_6 = { class: "text-left p-4" }
const _hoisted_7 = {
  key: 0,
  class: "text-left p-4"
}
const _hoisted_8 = { class: "text-left p-4" }
const _hoisted_9 = { class: "text-left p-4" }
const _hoisted_10 = { class: "text-left p-4" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "text-left p-4" }, null, -1))
const _hoisted_12 = { class: "p-4 text-gray-800" }
const _hoisted_13 = { class: "p-4" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "p-4 text-gray-800" }, null, -1))
const _hoisted_15 = {
  key: 0,
  class: "p-4 text-gray-600"
}
const _hoisted_16 = { class: "p-4 text-gray-600" }
const _hoisted_17 = { class: "p-4 text-gray-600" }
const _hoisted_18 = { class: "p-4 text-gray-600" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "p-4 text-gray-600" }, null, -1))
const _hoisted_20 = { class: "p-4 text-gray-800" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "font-semibold" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = { class: "p-4" }
const _hoisted_25 = { class: "p-4" }
const _hoisted_26 = {
  key: 0,
  class: "text-gray-500"
}
const _hoisted_27 = {
  key: 0,
  class: "p-4 text-gray-600"
}
const _hoisted_28 = { class: "p-4 text-gray-600" }
const _hoisted_29 = { class: "p-4 text-gray-600" }
const _hoisted_30 = { class: "p-4 text-gray-600" }
const _hoisted_31 = { class: "p-4 text-gray-600" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Продлить ссылку ")
const _hoisted_33 = { class: "p-4 text-gray-800" }
const _hoisted_34 = { class: "p-4" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "p-4 text-gray-800" }, null, -1))
const _hoisted_36 = {
  key: 0,
  class: "p-4 text-gray-600"
}
const _hoisted_37 = { class: "p-4 text-gray-600" }
const _hoisted_38 = { class: "p-4 text-gray-600" }
const _hoisted_39 = { class: "p-4 text-gray-600" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "p-4 text-gray-600" }, null, -1))
const _hoisted_41 = { class: "p-4 text-gray-800" }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { class: "font-semibold" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_45 = { class: "p-4" }
const _hoisted_46 = { class: "p-4" }
const _hoisted_47 = {
  key: 0,
  class: "text-gray-500"
}
const _hoisted_48 = {
  key: 0,
  class: "p-4 text-gray-600"
}
const _hoisted_49 = { class: "p-4 text-gray-600" }
const _hoisted_50 = { class: "p-4 text-gray-600" }
const _hoisted_51 = { class: "p-4 text-gray-600" }
const _hoisted_52 = { class: "p-4 text-gray-600" }
const _hoisted_53 = /*#__PURE__*/_createTextVNode(" Продлить ссылку ")

import { computed, Component, ref, onMounted } from "vue";
import {
  ArrowCircleRightIcon,
  CheckCircleIcon,
  DotsCircleHorizontalIcon,
  XCircleIcon,
} from "@heroicons/vue/solid";
import { Process } from "@/types/";
import ProcessUser from "@/types/documents/process/ProcessUser";
import Button from "@/components/common/Button.vue";
import {
  ProcessUserStatusesEnum,
  DocumentStatusesEnum,
} from "@/store/modules/document/state";
import ProcessUserSignInfoModal from "@/components/documents/ProcessUserSignInfoModal.vue";
import DocumentFiles from "@/types/documents/document/DocumentFiles";
import { formatDateTime } from "@/utils/date";
import ProcessUserDataService from "@/services/documents/process/users/ProcessUserDataService";
import { useToast } from "vue-toastification";


export default /*#__PURE__*/_defineComponent({
  props: {
    processes: null,
    documentId: null,
    documentFiles: null,
    documentStatus: null
  },
  setup(__props: any) {

const props = __props as {
  processes: Process[];
  documentId: string;
  documentFiles: Array<DocumentFiles>;
  documentStatus: string;
}

const processUserSignInfoModalIsShow = ref(false);
const processUserId = ref<string | null>(null);
const prolongingProcessUserId = ref<string | null>(null);
const toast = useToast();


const hasComments = computed(() => props.processes.some(process =>
  Boolean(process.comment?.trim()) || (process.processUsers || []).some(user => Boolean(user.comment?.trim()))
));

const statusIcons: Record<string, Component> = {
  DENIED: XCircleIcon,
  ACTIVE: ArrowCircleRightIcon,
  WAIT: DotsCircleHorizontalIcon,
  SUCCESS: CheckCircleIcon,
  CANCELLED: XCircleIcon,
};

const statusColors: Record<string, string> = {
  DENIED: "text-red-500",
  ACTIVE: "text-main",
  WAIT: "text-yellow-500",
  SUCCESS: "text-green-500",
  CANCELLED: "text-gray-500",
};

const statusBorderColors: Record<string, string> = {
  DENIED: "border-main",
  ACTIVE: "border-main",
  WAIT: "border-yellow-500",
  SUCCESS: "border-green-500",
  CANCELLED: "border-gray-400",
};

// Замещающий исполнитель сохраняется как дочерний process user (parentId),
// поэтому в таблице показываем только основные строки, а замещающего
// выводим припиской "(исполнено ФИО)" к строке инициатора-исполнителя.
const mainProcessUsers = (process: Process) =>
  (process.processUsers || []).filter((user) => !user.parentId);

const substituteFor = (process: Process, userProcess: ProcessUser) =>
  (process.processUsers || []).find(
    (user) => user.parentId === userProcess.id
  ) || null;

const canProlongExternalLink = (userProcess: ProcessUser) =>
  userProcess.status === ProcessUserStatusesEnum.ACTIVE &&
  userProcess.userInfo?.userType === "EXTERNAL";

const prolongExternalLink = async (id: string) => {
  prolongingProcessUserId.value = id;
  try {
    await ProcessUserDataService.prolongExternalLink(id);
    toast.success("Срок внешней ссылки продлён");
  } finally {
    prolongingProcessUserId.value = null;
  }
};

const isShowReworkProcesses = ref(true);
const isOtherProcessesActive = ref(true);
const processesRework = ref<Array<Process>>([]);
const processesOther = ref<Array<Process>>([]);
onMounted(() => {
  console.log(props.processes);
  if (props.documentStatus === "REWORK" || props.documentStatus === "NEW") {
    isShowReworkProcesses.value = false;
    isOtherProcessesActive.value = false;
  }

  props.processes.forEach((item) => {
    if (item.templateInfo.type === "SYSTEM") {
      processesRework.value.push(item);
    } else {
      processesOther.value.push(item);
    }
  });

  processesRework.value.sort(function (p1, p2) {
    return p1.createdAt - p2.createdAt;
  });
  processesOther.value.sort(function (p1, p2) {
    return p1.createdAt - p2.createdAt;
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "table-scroll",
      style: {"--table-min-width":"1120px"},
      tabindex: "0",
      role: "region",
      "aria-label": _ctx.$t('common.scrollableTable')
    }, [
      _createElementVNode("table", _hoisted_2, [
        _createElementVNode("tr", _hoisted_3, [
          _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.$t("processHistory.column.process")), 1),
          _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$t("processHistory.column.status")), 1),
          _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t("processHistory.column.executor")), 1),
          (_unref(hasComments))
            ? (_openBlock(), _createElementBlock("th", _hoisted_7, _toDisplayString(_ctx.$t("processHistory.column.comment")), 1))
            : _createCommentVNode("", true),
          _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t("processHistory.column.deadline")), 1),
          _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t("processHistory.column.start")), 1),
          _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t("processHistory.column.end")), 1),
          _hoisted_11
        ]),
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(processesRework.value, (process) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: process.id
                }, [
                  _createElementVNode("tr", {
                    class: _normalizeClass(["border-t-8 border-opacity-50", [statusBorderColors[process.status]]])
                  }, [
                    _createElementVNode("td", _hoisted_12, _toDisplayString(process.templateInfo.name), 1),
                    _createElementVNode("td", _hoisted_13, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(statusIcons[process.status]), {
                        class: _normalizeClass(["w-6 h-6 mx-auto", statusColors[process.status]])
                      }, null, 8, ["class"]))
                    ]),
                    _hoisted_14,
                    (_unref(hasComments))
                      ? (_openBlock(), _createElementBlock("td", _hoisted_15, _toDisplayString(process.comment?.trim() || ''), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("td", _hoisted_16, _toDisplayString(_unref(formatDateTime)(process.deadline)), 1),
                    _createElementVNode("td", _hoisted_17, _toDisplayString(_unref(formatDateTime)(process.createdAt)), 1),
                    _createElementVNode("td", _hoisted_18, _toDisplayString(_unref(formatDateTime)(process.finishedAt)), 1),
                    _hoisted_19
                  ], 2),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mainProcessUsers(process), (userProcess, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: userProcess.id
                    }, [
                      _createElementVNode("td", _hoisted_20, [
                        (!index)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_21, [
                              _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("processHistory.initiator")), 1),
                              _hoisted_23,
                              _createTextVNode(" " + _toDisplayString(process.createdByInfo.fullName), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_24, [
                        (_openBlock(), _createBlock(_resolveDynamicComponent(statusIcons[userProcess.status]), {
                          class: _normalizeClass(["w-6 h-6 mx-auto", statusColors[userProcess.status]])
                        }, null, 8, ["class"]))
                      ]),
                      _createElementVNode("td", _hoisted_25, [
                        _createTextVNode(_toDisplayString(userProcess.userInfo.fullName) + " ", 1),
                        (substituteFor(process, userProcess))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, " (" + _toDisplayString(_ctx.$t("processHistory.executedBy")) + ": " + _toDisplayString(substituteFor(process, userProcess)?.userInfo.fullName) + ") ", 1))
                          : _createCommentVNode("", true)
                      ]),
                      (_unref(hasComments))
                        ? (_openBlock(), _createElementBlock("td", _hoisted_27, _toDisplayString(userProcess.comment?.trim() || ''), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("td", _hoisted_28, _toDisplayString(_unref(formatDateTime)(process.deadline)), 1),
                      _createElementVNode("td", _hoisted_29, _toDisplayString(_unref(formatDateTime)(userProcess.startedAt)), 1),
                      _createElementVNode("td", _hoisted_30, _toDisplayString(_unref(formatDateTime)(userProcess.finishedAt)), 1),
                      _createElementVNode("td", _hoisted_31, [
                        (
                    process.isSigning &&
                    __props.documentStatus === _unref(DocumentStatusesEnum).SUCCESS &&
                    userProcess.status === _unref(ProcessUserStatusesEnum).SUCCESS
                  )
                          ? (_openBlock(), _createBlock(Button, {
                              key: 0,
                              onClick: ($event: any) => {
                    processUserId.value = userProcess.id;
                    processUserSignInfoModalIsShow.value = true;
                  }
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("processHistory.signInfo")), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true),
                        (canProlongExternalLink(userProcess))
                          ? (_openBlock(), _createBlock(Button, {
                              key: 1,
                              class: "ml-2",
                              disabled: prolongingProcessUserId.value === userProcess.id,
                              onClick: ($event: any) => (prolongExternalLink(userProcess.id))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_32
                              ]),
                              _: 2
                            }, 1032, ["disabled", "onClick"]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ], 64))
              }), 128))
            ], 512), [
              [_vShow, isShowReworkProcesses.value]
            ])
          ]),
          _: 1
        }),
        _createElementVNode("tbody", {
          class: _normalizeClass({ 'inactive-processes': isOtherProcessesActive.value })
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(processesOther.value, (process) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: process.id
            }, [
              _createElementVNode("tr", {
                class: _normalizeClass(["border-t-8 border-opacity-50", [statusBorderColors[process.status]]])
              }, [
                _createElementVNode("td", _hoisted_33, _toDisplayString(process.templateInfo.name), 1),
                _createElementVNode("td", _hoisted_34, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(statusIcons[process.status]), {
                    class: _normalizeClass(["w-6 h-6 mx-auto", statusColors[process.status]])
                  }, null, 8, ["class"]))
                ]),
                _hoisted_35,
                (_unref(hasComments))
                  ? (_openBlock(), _createElementBlock("td", _hoisted_36, _toDisplayString(process.comment?.trim() || ''), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("td", _hoisted_37, _toDisplayString(_unref(formatDateTime)(process.deadline)), 1),
                _createElementVNode("td", _hoisted_38, _toDisplayString(_unref(formatDateTime)(process.createdAt)), 1),
                _createElementVNode("td", _hoisted_39, _toDisplayString(_unref(formatDateTime)(process.finishedAt)), 1),
                _hoisted_40
              ], 2),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mainProcessUsers(process), (userProcess, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: userProcess.id
                }, [
                  _createElementVNode("td", _hoisted_41, [
                    (!index)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_42, [
                          _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.$t("processHistory.initiator")), 1),
                          _hoisted_44,
                          _createTextVNode(" " + _toDisplayString(process.createdByInfo.fullName), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", _hoisted_45, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(statusIcons[userProcess.status]), {
                      class: _normalizeClass(["w-6 h-6 mx-auto", statusColors[userProcess.status]])
                    }, null, 8, ["class"]))
                  ]),
                  _createElementVNode("td", _hoisted_46, [
                    _createTextVNode(_toDisplayString(userProcess.userInfo.fullName) + " ", 1),
                    (substituteFor(process, userProcess))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_47, " (" + _toDisplayString(_ctx.$t("processHistory.executedBy")) + ": " + _toDisplayString(substituteFor(process, userProcess)?.userInfo.fullName) + ") ", 1))
                      : _createCommentVNode("", true)
                  ]),
                  (_unref(hasComments))
                    ? (_openBlock(), _createElementBlock("td", _hoisted_48, _toDisplayString(userProcess.comment?.trim() || ''), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("td", _hoisted_49, _toDisplayString(_unref(formatDateTime)(process.deadline)), 1),
                  _createElementVNode("td", _hoisted_50, _toDisplayString(_unref(formatDateTime)(userProcess.startedAt)), 1),
                  _createElementVNode("td", _hoisted_51, _toDisplayString(_unref(formatDateTime)(userProcess.finishedAt)), 1),
                  _createElementVNode("td", _hoisted_52, [
                    (
                  process.isSigning &&
                  __props.documentStatus === _unref(DocumentStatusesEnum).SUCCESS &&
                  userProcess.status === _unref(ProcessUserStatusesEnum).SUCCESS
                )
                      ? (_openBlock(), _createBlock(Button, {
                          key: 0,
                          onClick: ($event: any) => {
                  processUserId.value = userProcess.id;
                  processUserSignInfoModalIsShow.value = true;
                }
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("processHistory.signInfo")), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true),
                    (canProlongExternalLink(userProcess))
                      ? (_openBlock(), _createBlock(Button, {
                          key: 1,
                          class: "ml-2",
                          disabled: prolongingProcessUserId.value === userProcess.id,
                          onClick: ($event: any) => (prolongExternalLink(userProcess.id))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_53
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onClick"]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ], 64))
          }), 128))
        ], 2)
      ])
    ], 8, _hoisted_1),
    _createVNode(ProcessUserSignInfoModal, {
      show: processUserSignInfoModalIsShow.value,
      onHide: _cache[0] || (_cache[0] = ($event: any) => (processUserSignInfoModalIsShow.value = false)),
      processUserId: processUserId.value,
      documentFiles: __props.documentFiles,
      documentId: __props.documentId
    }, null, 8, ["show", "processUserId", "documentFiles", "documentId"])
  ], 64))
}
}

})